let body = document.getElementById("body");
let title = document.getElementById("title");

export function AddBodyModifikator () {
    body.classList.add("bodyModofikator");
}

export function RemoveBodyModifikator () {
    body.classList.remove("bodyModofikator");
}

export function NexTitle (Text){
    title.innerHTML=Text;
}
